import { h } from 'preact';

import { formatContactHeadline, contactTypeLabel } from '../../lib/fishContact';
import { EntryDetails, EntryPosition } from '../fishEntry/entryCardParts';

// Everything shared with the catch card lives in fishEntry/entryCardParts.js.
// This file carries only what is contact-specific: the headline, the hook icon
// and the contact-type badge.
function FishContactCard({ fishContact }) {
    if (!fishContact) {
        return null;
    }

    const headline = formatContactHeadline(fishContact);
    const photo = fishContact.images?.[0]?.s3MediumLink;
    const typeLabel = contactTypeLabel(fishContact.contactType);

    return (
        <div class='card mb-2'>
            {photo && (
                <img src={photo} class='img-fluid rounded' alt={headline || ''} />
            )}
            <div class='card-body'>
                <div class='d-flex align-items-center justify-content-between flex-wrap gap-2'>
                    <span class='fw-bold'>
                        <i class='fa-solid fa-fish-hook me-2' />
                        {headline}
                    </span>
                    {!!typeLabel && (
                        <span class='badge text-bg-secondary'>
                            {typeLabel}
                        </span>
                    )}
                </div>

                <EntryDetails entry={fishContact} />
                <EntryPosition entry={fishContact} />
            </div>
        </div>
    );
}

export default FishContactCard;
